exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "iframe[data-v-0d625d40]{width:600px;max-width:100%;height:20rem;border:none;padding-top:10px;padding-bottom:15px}ul[data-v-0d625d40]{list-style:none;padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-0d625d40","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/MusicPage.vue
// module id = 19
// module chunks = 0